module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAAAiCAYAAAAUAipQAAAAAXNSR0IArs4c6QAAALNJREFUWAntlrENhEAMBAHRBk28ICFEJEh8ES+RUAZV0QFNEFLIsUhY5xbWvyRnOdoZ6zgXRdCvfLhSSj8cSyTG+oVpcPaRwKpIMJ5FYN4GQ20/jwFhR4bAyigDMiADMiADzoC9YxN6X9enL20J7kCy0tM4AO2KTgZFGXZidsdOjGGnGIVCyoAMyIAMyEA2YEvwB602t/kre6BnoGz8OJkg7EolsDxkjsru2IW4B0fkP095AxG+E2Mod5JGAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/menu.png
// module id = 103
// module chunks = 0